import { Injectable } from '@angular/core';
import { ProductListApiService } from '@epicuro-next/data/engagement/engagement-api';
import { ProductByBarcodeGQL } from '@epicuro-next/data/product';

import { ProductByBarcode } from '../models';

@Injectable()
export class ScannerApiService {
  constructor(
    private productByBarcodeGQL: ProductByBarcodeGQL,
    private productListService: ProductListApiService,
  ) {}

  /**
   * Exceptions handled
   * @param productBarcode
   */
  public searchProductByBarcode(productBarcode: string) {
    return this.productByBarcodeGQL.fetch({ productBarcode });
  }

  public addProductToList(
    listId: string,
    product: Pick<ProductByBarcode, 'productId' | 'brandId'>,
  ) {
    const payload = {
      id: listId,
      patchItems: {
        itemsToAdd: [
          {
            productId: product.productId,
            brandId: product.brandId,
          },
        ],
        itemsToDelete: [],
      },
    };
    return this.productListService.changeProducts(payload);
  }
}
